import React from 'react';
import { Mail, Send, Sparkles, Diamond, Gem } from 'lucide-react';

const Hero = () => {
  const handleEmailClick = () => {
    window.open('mailto:satis@tamayar.com', '_blank');
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0D0B09] via-[#1A1512] to-[#251E18]" />
      
      {/* Animated Gradient Orbs */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#C9A97B]/5 rounded-full blur-[120px] morph-shape" />
      <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-[#472F27]/30 rounded-full blur-[100px] morph-shape" style={{ animationDelay: '-4s' }} />
      
      {/* Diagonal Pattern Overlay */}
      <div className="absolute inset-0 diagonal-pattern opacity-50" />
      
      {/* Grid Pattern */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0wIDBoNjB2NjBIMHoiLz48cGF0aCBkPSJNMzAgMzBtLTEgMGExIDEgMCAxIDAgMiAwYTEgMSAwIDEgMCAtMiAwIiBmaWxsPSJyZ2JhKDIwMSwxNjksMTIzLDAuMDUpIi8+PC9nPjwvc3ZnPg==')] opacity-40" />

      {/* Floating Decorative Elements */}
      <div className="absolute top-20 left-10 md:left-20 opacity-20">
        <Diamond className="w-6 h-6 text-[#C9A97B] particle" style={{ animationDelay: '0s' }} />
      </div>
      <div className="absolute top-40 right-10 md:right-32 opacity-15">
        <Gem className="w-8 h-8 text-[#C9A97B] particle" style={{ animationDelay: '2s' }} />
      </div>
      <div className="absolute bottom-40 left-20 opacity-10 hidden md:block">
        <Diamond className="w-10 h-10 text-[#C9A97B] particle" style={{ animationDelay: '4s' }} />
      </div>
      <div className="absolute top-1/2 right-10 opacity-15 hidden lg:block">
        <Gem className="w-5 h-5 text-[#C9A97B] particle" style={{ animationDelay: '1s' }} />
      </div>

      {/* Decorative Lines - Left */}
      <div className="absolute left-0 top-1/4 w-32 h-px bg-gradient-to-r from-transparent via-[#C9A97B]/30 to-transparent hidden lg:block" />
      <div className="absolute left-0 top-1/3 w-48 h-px bg-gradient-to-r from-transparent via-[#C9A97B]/20 to-transparent hidden lg:block" />
      
      {/* Decorative Lines - Right */}
      <div className="absolute right-0 bottom-1/4 w-32 h-px bg-gradient-to-l from-transparent via-[#C9A97B]/30 to-transparent hidden lg:block" />
      <div className="absolute right-0 bottom-1/3 w-48 h-px bg-gradient-to-l from-transparent via-[#C9A97B]/20 to-transparent hidden lg:block" />

      {/* Vertical Decorative Lines */}
      <div className="absolute left-10 top-0 w-px h-40 bg-gradient-to-b from-transparent via-[#C9A97B]/20 to-transparent hidden lg:block" />
      <div className="absolute right-10 bottom-0 w-px h-40 bg-gradient-to-t from-transparent via-[#C9A97B]/20 to-transparent hidden lg:block" />

      {/* Rotating Ring Decoration */}
      <div className="absolute top-1/4 right-1/4 w-64 h-64 hidden xl:block">
        <div className="w-full h-full border border-[#C9A97B]/5 rounded-full rotate-slow" />
        <div className="absolute inset-4 border border-dashed border-[#C9A97B]/10 rounded-full rotate-slow" style={{ animationDirection: 'reverse', animationDuration: '30s' }} />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center">
          {/* Main Heading with decorative elements - CENTERED */}
          <div className="relative mb-6 animate-fade-in-up">
            {/* Corner decorations for heading */}
            <div className="absolute -top-4 left-1/2 -translate-x-[160px] md:-translate-x-[220px] lg:-translate-x-[280px] w-8 h-8 border-l-2 border-t-2 border-[#C9A97B]/30 rounded-tl-lg hidden md:block" />
            <div className="absolute -bottom-4 left-1/2 translate-x-[130px] md:translate-x-[190px] lg:translate-x-[250px] w-8 h-8 border-r-2 border-b-2 border-[#C9A97B]/30 rounded-br-lg hidden md:block" />
            
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-display font-bold leading-tight">
              <span className="text-[#F5F0E8]">Kuyumculuğun</span>
              <br />
              <span className="text-gold-gradient">Dijital Mihenk Taşı</span>
            </h1>
          </div>

          {/* Badge BELOW the heading - CENTERED */}
          <div className="flex justify-center mb-6 animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
            <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-[#C9A97B]/20 bg-[#C9A97B]/5 animated-border">
              <Sparkles className="w-4 h-4 text-[#C9A97B]" />
              <span className="text-sm text-[#C9A97B] font-medium">Kuyumcu Yönetim ve Barkod Sistemi</span>
            </div>
          </div>

          {/* Decorative line under badge */}
          <div className="flex items-center justify-center gap-4 mb-6 animate-fade-in-up" style={{ animationDelay: '0.15s' }}>
            <div className="w-12 h-px bg-gradient-to-r from-transparent to-[#C9A97B]/50" />
            <Diamond className="w-4 h-4 text-[#C9A97B]/50" />
            <div className="w-12 h-px bg-gradient-to-l from-transparent to-[#C9A97B]/50" />
          </div>

          {/* Subtitle */}
          <p className="text-lg sm:text-xl text-[#BFB5A5] max-w-3xl mx-auto mb-10 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            Canlı borsa entegrasyonu, akıllı CRM ve hibrit stok yönetimiyle 
            <span className="text-[#C9A97B]"> işinize tam ayar verin</span>. 
            Artık fiyat güncellemesiyle uğraşmayın, satışa odaklanın.
          </p>

          {/* CTA Button with glow */}
          <div className="flex items-center justify-center mb-16 animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
            <button
              onClick={handleEmailClick}
              className="group relative px-10 py-5 rounded-xl text-base font-semibold overflow-hidden bg-gradient-to-r from-[#C9A97B] via-[#D4BC94] to-[#C9A97B] text-[#1A1512] shadow-lg shadow-[#C9A97B]/30 hover:shadow-xl hover:shadow-[#C9A97B]/40 transition-shadow duration-500 shine-effect glow-gold"
            >
              {/* Animated background */}
              <div className="absolute inset-0 bg-gradient-to-r from-[#D4BC94] via-[#E8D5B5] to-[#D4BC94] opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              
              {/* Mail icon container - transforms to send animation */}
              <span className="relative flex items-center justify-center gap-3">
                {/* Envelope that opens on hover */}
                <span className="relative w-6 h-6">
                  {/* Mail icon - default state */}
                  <Mail className="absolute inset-0 w-6 h-6 transition-all duration-500 group-hover:opacity-0 group-hover:scale-75" />
                  {/* Send icon - hover state with fly animation */}
                  <Send className="absolute inset-0 w-6 h-6 opacity-0 scale-75 transition-all duration-500 group-hover:opacity-100 group-hover:scale-100 group-hover:translate-x-1 group-hover:-translate-y-1" />
                </span>
                
                <span className="relative transition-all duration-300 group-hover:tracking-wider">
                  Ücretsiz Deneyin
                </span>
              </span>

              {/* Sparkle effects on hover */}
              <span className="absolute top-2 right-4 w-1 h-1 bg-white rounded-full opacity-0 group-hover:opacity-100 group-hover:animate-ping" style={{ animationDelay: '0.1s' }} />
              <span className="absolute top-4 right-8 w-1.5 h-1.5 bg-white rounded-full opacity-0 group-hover:opacity-100 group-hover:animate-ping" style={{ animationDelay: '0.3s' }} />
              <span className="absolute bottom-3 right-6 w-1 h-1 bg-white rounded-full opacity-0 group-hover:opacity-100 group-hover:animate-ping" style={{ animationDelay: '0.2s' }} />
            </button>
          </div>

          {/* Device Mockups Container */}
          <div className="relative max-w-5xl mx-auto animate-fade-in-up px-4" style={{ animationDelay: '0.4s' }}>
            {/* Glow behind mockup */}
            <div className="absolute inset-0 bg-[#C9A97B]/5 blur-3xl rounded-full scale-75 pointer-events-none" />
            
            {/* Layout wrapper for mockup and floating elements */}
            <div className="relative flex items-center justify-center">
              {/* LEFT FLOATING - Price Tag */}
              <div 
                className="absolute left-0 lg:-left-4 xl:left-0 top-1/4 bg-[#251E18] rounded-xl p-3 md:p-4 shadow-2xl border border-[#C9A97B]/20 hidden lg:block animate-float z-30 corner-decoration" 
                style={{ animationDelay: '1s' }}
              >
                <div className="text-xs text-[#7A7067] mb-1">Anlık Altın Fiyatı</div>
                <div className="text-xl md:text-2xl font-display font-bold text-gold-gradient">₺2.847,50</div>
                <div className="text-xs text-green-500 mt-1 flex items-center gap-1">
                  <span className="inline-block w-0 h-0 border-l-[4px] border-l-transparent border-r-[4px] border-r-transparent border-b-[6px] border-b-green-500" />
                  +12,30 (+0.43%)
                </div>
              </div>

              {/* MAIN DASHBOARD MOCKUP */}
              <div className="relative gradient-border-card p-2 shadow-2xl w-full max-w-3xl mx-16 lg:mx-28">
                {/* Browser Top Bar */}
                <div className="flex items-center gap-2 px-4 py-3 bg-[#1A1512] rounded-t-xl border-b border-[#C9A97B]/10">
                  <div className="flex gap-2">
                    <div className="w-3 h-3 rounded-full bg-[#472F27]" />
                    <div className="w-3 h-3 rounded-full bg-[#5A4A3A]" />
                    <div className="w-3 h-3 rounded-full bg-[#C9A97B]/50" />
                  </div>
                  <div className="flex-1 flex justify-center">
                    <div className="px-4 py-1 rounded-full bg-[#251E18] text-xs text-[#7A7067] border border-[#C9A97B]/10">
                      app.tamayar.com
                    </div>
                  </div>
                </div>
                
                {/* Dashboard Preview */}
                <div className="aspect-[16/9] bg-gradient-to-br from-[#1A1512] to-[#0D0B09] rounded-b-xl overflow-hidden">
                  <div className="h-full p-4 md:p-6 grid grid-cols-4 gap-3 md:gap-4">
                    {/* Sidebar */}
                    <div className="col-span-1 bg-[#251E18]/50 rounded-xl p-3 md:p-4 space-y-2 md:space-y-3 border border-[#C9A97B]/5">
                      <div className="h-6 md:h-8 bg-[#C9A97B]/20 rounded-lg" />
                      <div className="h-5 md:h-6 bg-[#C9A97B]/10 rounded w-3/4" />
                      <div className="h-5 md:h-6 bg-[#C9A97B]/10 rounded w-2/3" />
                      <div className="h-5 md:h-6 bg-[#C9A97B]/10 rounded w-4/5" />
                      <div className="h-5 md:h-6 bg-[#C9A97B]/20 rounded" />
                      <div className="h-5 md:h-6 bg-[#C9A97B]/10 rounded w-1/2" />
                    </div>
                    
                    {/* Main Content */}
                    <div className="col-span-3 space-y-3 md:space-y-4">
                      {/* Stats Row */}
                      <div className="grid grid-cols-4 gap-2 md:gap-3">
                        {[1, 2, 3, 4].map((i) => (
                          <div key={i} className="bg-[#251E18]/50 rounded-xl p-2 md:p-4 border border-[#C9A97B]/5">
                            <div className="h-2 md:h-3 bg-[#C9A97B]/30 rounded w-1/2 mb-1 md:mb-2" />
                            <div className="h-4 md:h-6 bg-[#C9A97B]/20 rounded w-3/4" />
                          </div>
                        ))}
                      </div>
                      
                      {/* Chart Area */}
                      <div className="bg-[#251E18]/50 rounded-xl p-3 md:p-4 h-24 md:h-32 border border-[#C9A97B]/5">
                        <div className="flex items-end h-full gap-1 md:gap-2">
                          {[40, 65, 45, 80, 55, 90, 70, 85, 60, 75, 50, 95].map((h, i) => (
                            <div
                              key={i}
                              className="flex-1 bg-gradient-to-t from-[#C9A97B] to-[#C9A97B]/30 rounded-t transition-all duration-300 hover:from-[#D4BC94] hover:to-[#D4BC94]/30"
                              style={{ height: `${h}%` }}
                            />
                          ))}
                        </div>
                      </div>
                      
                      {/* Table Preview */}
                      <div className="bg-[#251E18]/50 rounded-xl p-3 md:p-4 space-y-2 border border-[#C9A97B]/5">
                        {[1, 2, 3].map((i) => (
                          <div key={i} className="flex gap-2 md:gap-4">
                            <div className="h-3 md:h-4 bg-[#C9A97B]/10 rounded flex-1" />
                            <div className="h-3 md:h-4 bg-[#C9A97B]/20 rounded w-16 md:w-24" />
                            <div className="h-3 md:h-4 bg-[#C9A97B]/10 rounded w-12 md:w-20" />
                            <div className="h-3 md:h-4 bg-[#C9A97B]/30 rounded w-10 md:w-16" />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                {/* NOTIFICATION BADGE - Top right of mockup */}
                <div 
                  className="absolute bg-[#251E18] rounded-lg px-3 py-2 shadow-lg border border-[#C9A97B]/20 hidden xl:flex items-center gap-2 animate-float z-30" 
                  style={{ 
                    animationDelay: '2s',
                    right: '20px',
                    top: '-16px'
                  }}
                >
                  <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
                  <span className="text-xs text-[#BFB5A5]">3 yeni sipariş</span>
                </div>
              </div>

              {/* RIGHT FLOATING - Tablet Mockup */}
              <div 
                className="absolute right-0 lg:-right-4 xl:right-0 top-1/3 w-28 lg:w-32 xl:w-36 gradient-border-card p-1 shadow-2xl hidden lg:block animate-float z-30"
              >
                <div className="aspect-[3/4] bg-gradient-to-br from-[#1A1512] to-[#0D0B09] rounded-lg p-2">
                  <div className="h-full space-y-1.5">
                    <div className="h-3 bg-[#C9A97B]/20 rounded w-2/3" />
                    <div className="grid grid-cols-2 gap-1 flex-1">
                      {[1, 2, 3, 4].map((i) => (
                        <div key={i} className="bg-[#251E18]/50 rounded p-1 border border-[#C9A97B]/5">
                          <div className="aspect-square bg-[#C9A97B]/10 rounded mb-0.5" />
                          <div className="h-1 bg-[#C9A97B]/20 rounded" />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Trust Badges with enhanced styling */}
          <div className="mt-16 animate-fade-in-up" style={{ animationDelay: '0.5s' }}>
            {/* Decorative line above badges */}
            <div className="flex items-center justify-center gap-4 mb-6">
              <div className="w-16 md:w-24 h-px bg-gradient-to-r from-transparent to-[#C9A97B]/30" />
              <span className="text-[#7A7067] text-xs uppercase tracking-widest">Güvenle Kullanın</span>
              <div className="w-16 md:w-24 h-px bg-gradient-to-l from-transparent to-[#C9A97B]/30" />
            </div>
            
            <div className="flex flex-wrap items-center justify-center gap-6 md:gap-8">
              {[
                { icon: 'shield', text: 'SSL Güvenliği' },
                { icon: 'check', text: 'KVKK Uyumlu' },
                { icon: 'support', text: '7/24 Destek' },
                { icon: 'gift', text: 'Ücretsiz Kurulum' },
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-2 text-[#7A7067] group">
                  <div className="w-8 h-8 rounded-lg bg-[#C9A97B]/10 flex items-center justify-center group-hover:bg-[#C9A97B]/20 transition-colors">
                    <svg className="w-4 h-4 text-[#C9A97B]" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <span className="text-sm group-hover:text-[#BFB5A5] transition-colors">{item.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Gradient Fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-[#0D0B09] to-transparent" />
    </section>
  );
};

export default Hero;
